import { useBatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore/BatchSkiptraceStoreLive'

export const useBatchSelectionUnskiptracedCount = () =>
  useBatchSkiptraceStore(store => store.selectionUnskiptracedCount.state)
